import ConfirmDialog from './ConfirmDialog';
import MessageBox from './MessageBox';
import TagDialog from './TagDialog';

export { showConfirmDialog } from './ConfirmDialog';
export { showMessageBox } from './MessageBox';
export { showTagDialog } from './TagDialog';
export * from './utils';

export function Modals() {
  return (
    <>
      <ConfirmDialog />
      <MessageBox />
      <TagDialog />
    </>
  );
}
